import {scroller} from './scroller';
export function scrollPageTop() {
  $(document).on('click', '.js-page-top', function() {
    $('body,html').stop();
    scroller(0, 1200, 'easeInOutExpo');
    $('#header-nav-container').removeClass('is-show-sp');
    $('#header-sp-trigger').removeClass('is-sp-nav-active');
    $('#header-sp-overlay').removeClass('is-sp-nav-active');
    $(document.body).removeClass('is-sp-nav-active');
    return false;
  });
}